export const MARKETPLACE_ROLES = [5, 6];
export const APP_ROLE_MARKETPLACE = 'MARKETPLACE_USER';
export const APP_ROLE_STORE = 'STORE_USER';
export const STORE_ROLES = [11, 12];
export const ALLOWED_ROLES = [...MARKETPLACE_ROLES, ...STORE_ROLES];
